<template>
  <div class="layout-container">
    <Header />
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import Header from "@/layout/Header.vue";
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox } from "element-plus";

const router = useRouter();
const route = useRoute();
const userInfo = ref({
  username: "",
  role: "",
});

onMounted(() => {
  const storedInfo = localStorage.getItem("userInfo");
  if (storedInfo) {
    userInfo.value = JSON.parse(storedInfo);
  }
});

const handleCommand = async (command: string) => {
  if (command === "logout") {
    await ElMessageBox.confirm("确定要退出登录吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    router.push("/login");
  }
};
</script>

<style scoped>
.layout-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #dcdfe6;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}
</style>
